// Français (vouvoiement, comme la plupart des grandes applis).
export default {
  nav: {
    home: "Accueil",
    search: "Rechercher",
    explore: "Explorer",
    messages: "Messages",
    tribzz: "Tribzz",
    channels: "Chaînes",
    settings: "Réglages",
  },

  language: {
    title: "Langue",
    lead: "Choisissez la langue de Tribzz. Elle suit votre compte jusque dans l'appli sur votre téléphone.",
    note: "Les publications et les messages restent dans la langue où ils ont été écrits. Quelques écrans sont encore en cours de traduction et s'affichent en anglais pour l'instant.",
    saved: "✓ Enregistré",
    saving: "Enregistrement…",
    error: "Impossible d'enregistrer. Vérifiez votre connexion et réessayez.",
    done: "Terminé",
  },

  settings: {
    kicker: "Votre compte",
    title: "Réglages",
    editPhoto: "Modifier la photo de profil",
    member: "Membre",
    profileComplete: "Profil complété à {pct} %",
    quickEdit: "👤 Modifier le profil",
    quickTribzz: "◆ Mes Tribzz",
    quickSecurity: "🔐 Sécurité",
    finishTitle: "Complétez votre profil",
    finishSub: "Ajoutez votre {fields} pour qu'on sache que c'est vous.",
    gathering: "Chargement de votre compte…",
    fields: {
      name: "nom complet",
      image: "photo de profil",
      email: "e-mail",
      phone: "téléphone",
      description: "bio",
      more: "et {n} de plus",
    },
    sections: {
      account: "Compte",
      membership: "Abonnement",
      create: "Créer et gagner",
      stuff: "Vos contenus",
      community: "Communauté et applis",
      support: "Assistance",
    },
    rows: {
      personal: { title: "Informations personnelles", sub: "Nom, pseudo, photo, centres d'intérêt, confidentialité" },
      profilePage: { title: "Votre page de profil", sub: "Voyez ce que les autres voient" },
      security: { title: "Sécurité", sub: "Mot de passe et connexions récentes" },
      notifications: { title: "Notifications", sub: "Alertes du téléphone, e-mails et heures calmes" },
      language: { title: "Langue", sub: "La langue de Tribzz pour vous" },
      creator: { title: "Tableau de bord créateur", sub: "Revenus, vues réelles, extraits, sorties et lives" },
      business: { title: "Outils pro", sub: "Vente à emporter, réservations, billets et devis pour votre Tribzz" },
      pro: { title: "Tribzz Pro", sub: "Proposez vos services : faites-vous vérifier, trouver et réserver" },
      tickets: { title: "Mes billets", sub: "Billets d'événements et leurs QR codes" },
      savedShorts: { title: "Shorts enregistrés" },
      memories: { title: "Souvenirs" },
      invite: { title: "Inviter des amis", sub: "Faites venir vos proches sur Tribzz" },
      muzilly: { title: "Muzilly" },
      ideas: { title: "Boîte à idées", sub: "Votez pour la prochaine nouveauté de Tribzz" },
      help: { title: "Aide et FAQ", sub: "Réponses et assistance" },
      about: { title: "À propos de Tribzz", sub: "Version, conditions et confidentialité" },
    },
    pctLeft: "Encore {n} %",
    plan: {
      admin: "Admin",
      subscriber: "◆ Abonné",
      free: "Membre gratuit",
    },
    membership: {
      fullAccess: "Accès complet",
      adminText: "Toutes les fonctionnalités, pour les tests. Ce n'est pas une offre payante : rien à gérer ni à résilier.",
      adminUsage: "{n} minutes de live utilisées ce mois-ci · sans limite",
      perMonth: "5 $ / mois",
      usage: "{used} sur {cap} minutes de live utilisées ce mois-ci",
      manage: "Gérer l'abonnement",
      opening: "Ouverture…",
      kicker: "◆ Abonnement Tribzz",
      bigLead: "Passez en live, publiez plus,",
      bigAccent: "soutenez Tribzz.",
      perk1: "Publiez plusieurs photos à la fois",
      perk2: "Passez en live et regardez les lives des autres membres",
      perk3: "Pas de pub, et vos données ne sont jamais vendues",
      subscribe: "S'abonner · 5 $ / mois",
      redirecting: "Redirection…",
    },
    library: {
      shortsEmpty: "Vos shorts enregistrés et vos playlists",
      saved: "{n} enregistrés",
      playlists: "{n} playlist | {n} playlists",
      memoriesEmpty: "Vos propres stories, conservées au-delà de 24 heures",
      memories: "{n} souvenir | {n} souvenirs",
      freeSaves: "{used} sur {limit} enregistrements gratuits utilisés",
    },
    muzilly: {
      connectedAs: "Connecté en tant que {name}",
      yourAccount: "votre compte Muzilly",
      yourAccountTitle: "Votre compte Muzilly",
      connectPrompt: "Artistes et auditeurs : connectez votre compte",
      connected: "● Connecté",
      linkedBody: "{name} : si vous êtes artiste, ce que vous publiez ici en public apparaît sur votre page Muzilly. Si vous êtes auditeur, les morceaux que vous écoutez ici comptent pour les artistes que vous suivez.",
      intro: "Artistes : vos publications publiques apparaissent sur votre page Muzilly. Auditeurs : les morceaux que vous écoutez ici comptent pour les artistes que vous suivez.",
      step1: "Ouvrez Muzilly et allez sur votre profil.",
      step2: "Touchez Connecter Tribzz pour obtenir un code de 8 caractères.",
      step3: "Saisissez-le ci-dessous : il reste valable 10 minutes.",
      codeLabel: "Code Muzilly",
      close: "Fermer",
      cancel: "Annuler",
      disconnect: "Déconnecter",
      working: "En cours…",
      connect: "Connecter",
      connecting: "Connexion…",
      errConnect: "Connexion impossible. Essayez avec un nouveau code.",
      errDisconnect: "Déconnexion impossible.",
    },
    signOut: "Se déconnecter",
    deleteAccount: "Supprimer le compte",
    deleteWarning: "La suppression de votre compte est définitive et immédiate. Vos publications, messages, check-ins et connexions sont effacés sur-le-champ, sans retour possible.",
    deleteButton: "Supprimer mon compte…",
    deleteTitle: "Supprimer votre compte ?",
    deleteText: "Cela efface définitivement et immédiatement votre profil, vos publications, vos messages et vos connexions. Impossible d'annuler.",
    typeDelete: "Tapez DELETE pour confirmer",
    cancel: "Annuler",
    deleting: "Suppression…",
    deleteForever: "Supprimer définitivement",
  },

  home: {
    notifications: "Notifications",
    overline: "La plateforme des gens · {date}",
    welcome: "◆ Bon retour, {name} ◆",
    welcomeAnon: "◆ Bon retour ◆",
    deck: "Vos cercles, votre culture : tout ce qui suit, c'est la une du jour.",
    news: {
      label: "Actus Tribzz",
      all: "Toutes les actus →",
      listenTop: "Écouter l'article à la une",
      listenLatest: "Écouter les dernières · {n} articles",
      topStory: "★ À LA UNE",
      newsroom: "· Rédaction Tribzz",
      read: "Lire l'article →",
      minRead: "{n} min de lecture",
      listen: "🎧 Écouter",
    },
    topics: {
      local: "📍 Local",
      politics: "🗳 Politique",
      government: "🏛 Gouvernement",
      crime: "⚖️ Faits divers et justice",
      business: "💼 Économie",
      education: "🎓 Éducation",
      health: "🩺 Santé",
      sports: "🏀 Sport",
      culture: "🎨 Culture",
      tech: "💻 Tech",
      environment: "🌱 Environnement",
      community: "🤝 Communauté",
      news: "📰 Actus",
    },
    ago: {
      minutes: "il y a {n} min",
      hours: "il y a {n} h",
      days: "il y a {n} j",
    },
    share: "Partagez quelque chose",
    watch: {
      label: "Regarder et créer",
      browseChannels: "Voir les chaînes",
      startChannel: "Créer une chaîne",
      watchShorts: "Regarder des shorts",
      browseStores: "Voir les boutiques",
      launchStore: "Lancer une boutique",
    },
    explore: {
      label: "Dans Explorer",
      headLine1: "Ce qui se dit",
      headLine2: "en ce moment",
      intro: "C'est dans Explorer que la culture se passe vraiment. Un coup d'œil à la une du jour ; le reste est à portée de doigt.",
      loading: "Préparation de l'édition du jour…",
      house: "◆ Tribzz Daily",
      aMember: "Un membre",
      inGroup: "dans {name}",
      readOn: "Lire dans Explorer →",
      emptyTitle: "La une est vide.",
      emptySub: "Rien n'a été publié ces dernières 24 heures. Soyez le premier.",
      enter: "Entrer dans Explorer",
      vanishing: "Bientôt disparu",
      hoursLeft: "Encore {n} h",
    },
    live: {
      label: "En ce moment",
      headA: "Tribzz publics",
      headLive: "en live",
      headB: "maintenant",
      intro: "Ouverts à tous : entrez et regardez, même sans les avoir rejoints.",
      badge: "● EN LIVE",
    },
    circles: {
      label: "Vos cercles",
      headA: "Qui est",
      headLive: "en live",
      headB: "en ce moment",
      intro: "Chaque Tribzz est un lieu à part, tenu par la personne qui l'a créé. Voici qui est en live, et qui a fait son check-in, à l'instant.",
      loading: "On regarde qui est là…",
      hereNow: "{n} présents",
      nobody: "Personne n'a encore fait de check-in",
      emptyTitle: "Vous n'avez encore rejoint aucun Tribzz.",
      emptySub: "Un restaurant, une équipe, une personne : tout le monde peut en créer un. Trouvez le vôtre, ou créez-le.",
      browse: "Voir les Tribzz",
      start: "Créer le vôtre",
    },
    people: {
      label: "Votre cercle",
      headA: "Des personnes",
      headB: "à rencontrer",
      intro: "Des Tribzz en commun, la même ville, les mêmes centres d'intérêt : quoi que vous ayez en commun, on le trouve.",
      loading: "On cherche vos proches…",
      activeNow: "En ligne",
      member: "Membre",
      inGroup: "Dans {name} avec vous",
      alsoInto: "Aime aussi {interest}",
      view: "Voir le profil",
      connected: "Connectés ✓",
      connect: "Se connecter",
      emptyTitle: "Aucune suggestion pour l'instant.",
      emptySub: "Ajoutez vos centres d'intérêt ou votre ville dans Informations personnelles, ou rejoignez un Tribzz : chacun de ces gestes nous aide à trouver vos proches.",
    },
    connections: {
      headA: "Mes",
      headB: "connexions",
      loading: "Chargement de vos connexions…",
      emptyTitle: "Pas encore de connexions.",
      emptySub: "Connectez-vous avec les personnes ci-dessus et elles apparaîtront ici.",
    },
  },

  categories: {
    moment: "Moment",
    here_now: "Ici maintenant",
    ask: "Question",
    poll: "Sondage",
    mood: "Humeur",
    travel_plan: "Projet de voyage",
    music: "Musique",
  },

  daily: {
    question: "Question du jour",
    poll: "Sondage",
    wyr: "Tu préfères",
    quote: "Citation",
    trivia: "Quiz",
    fact: "Le saviez-vous ?",
    riddle: "Devinette",
    history: "C'est arrivé un jour comme aujourd'hui",
    recipe: "Recette express",
    diy: "Tuto",
  },
};